<div class="container my-5">
  <div class="row justify-content-center">
    <div class="col-lg-8">

      @if (word) {
        <div class="card shadow-sm">
          <div class="card-body p-4">

            
            <div class="d-flex align-items-center justify-content-between mb-4">
              <h5 class="mb-0 fw-bold text-body-secondary">Word Details</h5>
              <div class="d-flex gap-2">
                <span class="badge bg-primary-subtle text-primary-emphasis fs-6">
                  {{ flags[word.language.name] }} {{ word.language.name }}
                </span>
                <span class="text-body-secondary">&rarr;</span>
                <span class="badge bg-success-subtle text-success-emphasis fs-6">
                  {{ flags[word.languageTo.name] }} {{ word.languageTo.name }}
                </span>
              </div>
            </div>

            
            <div class="row g-4 mb-4">
              <div class="col-md-6">
                <div class="card bg-light border-0 h-100">
                  <div class="card-body">
                    <p class="text-body-secondary small mb-1">Sentence</p>
                    <p class="fs-4 fw-semibold mb-0">{{ word.sentence }}</p>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card bg-light border-0 h-100">
                  <div class="card-body">
                    <p class="text-body-secondary small mb-1">Translation</p>
                    <p class="fs-4 fw-semibold mb-0">{{ word.translation }}</p>
                  </div>
                </div>
              </div>
            </div>

            
            @if (word.description.trim()) {
              <div class="card bg-light border-0 mb-3">
                <div class="card-body">
                  <p class="text-body-secondary small mb-1">Description</p>
                  <p class="mb-0">{{ word.description }}</p>
                </div>
              </div>
            }

            
            @if (word.tags?.length) {
              <div class="d-flex flex-wrap gap-2 mt-3">
                @for (tag of word.tags!; track tag.tag) {
                  <span class="badge rounded-pill bg-primary-subtle text-primary-emphasis px-3 py-2">
                    {{ tag.label }}
                  </span>
                }
              </div>
            }

            
            <div class="d-flex gap-2 mt-4">
              <a [routerLink]="['/word/edit', word.uuid]" class="btn btn-warning btn-sm">
                <i class="bi bi-pencil me-1"></i>Edit
              </a>
              <a routerLink="/word/list" class="btn btn-outline-secondary btn-sm">
                <i class="bi bi-arrow-left me-1"></i>Back to list
              </a>
            </div>

          </div>
        </div>
      } @else {
        <div class="text-center py-5">
          <div class="spinner-border text-primary" role="status"></div>
          <p class="mt-2 text-body-secondary">Loading word details...</p>
        </div>
      }

    </div>
  </div>
</div>
